import { useMutation } from "@tanstack/react-query"
import { modifyOvertimeHours } from "../api/payrollNoveltyApi";
import { PreliquidationHourSummaryRequest } from "../models/requests";

export const useModifyOvertimeHours = () => {
    return useMutation({
        mutationFn: ({ id, model } : {
            id: number,
            model: PreliquidationHourSummaryRequest
        }) => modifyOvertimeHours(id, model)
    });
}